import { LocalDateTime } from 'js-joda';
import { OfferingSummaryTitle } from 'components/business/receipts/OfferingSummary/OfferingSummaryTitle';
import { ReservationMetadataList } from 'components/business/reservation/ReservationMetadataList';
import { consumer, core } from '@tock/coretypes';
import { layoutSpacing } from 'components/business/receipts/OfferingSummary/offeringSummaryHeaderCssDefs';

interface ReceiptOfferingSummaryProps {
  business: consumer.IBusinessConfig;
  isAuthenticated: boolean;
  /**
   * When true, the business name is a link
   */
  isInteractive?: boolean;
  purchase: core.PastPurchase;
}

export const OfferingSummaryHeader: React.FC<ReceiptOfferingSummaryProps> = ({
  business,
  isAuthenticated,
  isInteractive = false,
  purchase,
}) => {
  const { ownerPatron, seatingAreaName, ticketCount, ticketDateTime, ticketType } = purchase;
  const latestDiner = purchase.dinerPatron[purchase.dinerPatron.length - 1];

  if (!ticketType || !ownerPatron || !business.name || !latestDiner || !latestDiner.id) {
    if (window.LOGGER) {
      const data = { ticketType, ownerPatron, latestDiner };
      window.LOGGER?.warn('Receipt was lacking required information', data);
    }
    return null;
  }

  const dateTime = LocalDateTime.parse(ticketDateTime);
  const imgAttributes = business.profileImage?.[0] ?? {};
  const businessUrl = isInteractive && business.domainName ? `/${business.domainName}` : undefined;
  const purchaseDiner = {
    id: latestDiner.id,
    firstName: latestDiner.firstName,
    lastName: latestDiner.lastName,
    email: latestDiner.email,
  };

  return (
    <div css={layoutSpacing}>
      <OfferingSummaryTitle
        businessName={business.name}
        offeringName={ticketType.name ?? ''}
        imgSrc={imgAttributes.imageBackingUrl}
        imgAlt={imgAttributes.altText}
        href={businessUrl}
      />
      <ReservationMetadataList
        showDateAndTime
        combineDateAndTime
        dateTime={dateTime}
        displayWeekdayAs="short"
        showQuantity
        ticketTypeVariety={ticketType.variety ?? undefined}
        ticketTypeDescriptiveVariety={ticketType.descriptiveVariety ?? undefined}
        singleUnitQuantity={ticketType.singleUnitQuantity ?? undefined}
        deliveryServiceProvider={ticketType.deliveryServiceProvider ?? undefined}
        purchaseCount={ticketCount}
        showDinerAndOwner={isAuthenticated}
        showPatronEmail={!isAuthenticated}
        purchaseDiner={purchaseDiner}
        purchaseOwner={ownerPatron}
        showSeatingArea
        seatingAreaName={seatingAreaName}
        typographyVariant="body02"
      />
    </div>
  );
};
